(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceDeleteController',GrievanceDeleteController);

    GrievanceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Grievance'];

    function GrievanceDeleteController($uibModalInstance, entity, Grievance) {
        var vm = this;

        vm.grievance = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Grievance.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
